import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getMechanicPromotions } from "../../services/promotion";
import { PROMOTIONS_CRUMBS } from "../../constants/crumbs";
import { promotionsMapper } from "../../helpers/dataMapper";
import { scrollToSection } from "../../helpers/global";
import PortalBreadcrumb from "../UI/Breadcrumb/PortalBreadcrumb/PortalBreadcrumb";
import Loading from "../UI/Loading/Loading";
import EmptyContent from "../UI/EmptyContent/EmptyContent";
import Promotion from "./Promotion/Promotion";
import classes from "./Promotions.module.css";

const Promotions = () => {
  const [promotions, setPromotions] = useState([]);
  const [isPromotionsLoading, setIsPromotionsLoading] = useState(true);
  const [promotionsLoadingError, setPromotionsLoadingError] = useState("");
  const { state: promotionId } = useLocation();
  const promotionsListRef = useRef();

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        setIsPromotionsLoading(true);
        setPromotionsLoadingError("");
        const response = await getMechanicPromotions();
        const {
          data: {
            data: { promotionProgressList },
          },
        } = response;
        setPromotions(promotionsMapper(promotionProgressList));
      } catch (err) {
        setPromotionsLoadingError("لا يوجد خصومات لعرضها !");
      } finally {
        setIsPromotionsLoading(false);
      }
    };

    fetchPromotions();
  }, []);

  useEffect(() => {
    if (promotionId && promotions.length > 0 && promotionsListRef.current) {
      scrollToSection(`promotion_${promotionId}`, promotionsListRef.current);
    }
  }, [promotionId, promotions]);

  return (
    <div className={classes["promotions"]}>
      <PortalBreadcrumb paths={PROMOTIONS_CRUMBS} />
      <div className={classes["container"]}>
        {isPromotionsLoading ? (
          <Loading className={classes["container__loading"]} />
        ) : promotionsLoadingError || promotions.length === 0 ? (
          <EmptyContent
            className={classes["container__empty"]}
            message="لا يوجد خصومات لعرضها !"
            withAction
          />
        ) : (
          <ul className={classes["promotion-list"]} ref={promotionsListRef}>
            {promotions.map((promotion, index) => (
              <Promotion
                key={index}
                id={promotion.id}
                name={promotion.campaignName}
                value={promotion.value}
                criteriaList={promotion.criteriaProgressList}
              />
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Promotions;
